<template>
	<div class="flex flex-col font-cooper bg-color-4 text-color-text font-semibold text-3xl rounded-lg">
		<div class="flex items-center">
			<div class="flex flex-col items-center grow px-4 py-1">
				<div>{{ $t('eny.amount') }}</div>
				<div>{{ $t('eny.chf') }} {{ amount_view }}</div>
			</div>
			<div class="flex flex-col items-center grow px-4 py-1">
				<div>{{ $t('eny.duration') }}</div>
				<div>{{ request.credit_duration }} {{$t('eny.months')}}</div>
			</div>
			<div v-if="user.first_name || user.given_name" class="flex flex-col items-center grow px-4 py-1">
				<div>{{ user.given_name }}</div>
				<div>{{ user.family_name }}</div>
			</div>
		</div>
		<div class="flex flex-col items-center font-cooper">
			<div class="flex flex-col items-center px-10 py-1 w-full">
				<offer-stepper v-bind:activeStep="offer_step" :stepItems="offerStepItems" cssClass="w-full mb-2"/>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import Stepper from "../../Base/Stepper.vue";
export default {
	name: "OfferRequest",
	components: {
		'offer-stepper': Stepper,
	},
	computed: {
		...mapGetters('customer', ['amount_view', 'request', 'user', 'offer_step']),
	},
	data() {
		return {
			offerStepItems: [
				{ text: '1' },
				{ text: '2' },
				{ text: '3' },
				{ text: '4' },
				{ text: '5' }
			],
		}
	},
}
</script>
